import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../../components/shared/Loading";
import { redirectAuthenticatedUser } from "../../../router/auth";

const Screen = lazy(() => import("../../../views/auth/ResetPassword"));

export const Route = createFileRoute(
  "/_public/reset-password/$resetPasswordAccessToken",
)({
  component: RouteComponent,
  params: {
    parse: (params) => (params.resetPasswordAccessToken ? params : false),
  },
  beforeLoad: redirectAuthenticatedUser,
  staticData: {
    routeKey: "resetPassword",
    access: "public-auth",
    layout: "modern",
    container: "default",
  },
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <Screen />
    </Suspense>
  );
}
